import React, { Component } from 'react'
import { Row, Col, Input, Modal, DatePicker, Select, message } from 'antd';
import $ from 'jquery';

const { RangePicker } = DatePicker;
const Option = Select.Option;
class NewHoliday extends Component {

    constructor( props ){

        super( props );

        this.state = {
            visible          : false,
            holiday_name     : 'none',
            holiday_dates    : [],
            holiday_type     : 'holiday',
            company_id       : 'none',
            users            : 'none',
            user_list        : [],
        }

        this.handleUsers = this.handleUsers.bind( this );

    }

    handleUsers( value ){

        let temp_user = '';
        let temp = '';
        
        if( value[0] === 'all' || value.length === 0 ){
            
            this.state.user_list.map((item, i) => {
                temp += item.user_id + '-';
            });

            this.setState({
                users: temp.substring(0, temp.length - 1)
            });

        } else {
            
            value.map( (item, i) => {
                temp_user += item + '-';
            });

            this.setState({
                users: temp_user.substring(0, temp_user.length - 1)
            });

        }

    }

    handleOk = (e) => {
        
        if( this.state.company_id === "" || this.state.company_id === "none" && 
            this.state.holiday_name === "" || this.state.holiday_name === "none" &&
            this.state.users === "" || this.state.users === "none" ){
                
            message.error( "All fields are mandatory!" );
            return false;
        
        }

        if( this.state.holiday_dates.length === 0 ){
            message.error( "field 'Holiday Dates' cannot be empty!" );
            return false;
        }

        this.props.onSubmit( this.state );
        this.setState({ visible: false });
    
    }

    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }

    componentWillReceiveProps( nextProps ){
        // Clear Input
        $('input').val( '' );
        
        this.setState({
            visible: nextProps.onModel,
            user_list: nextProps.user_data
        });
    
    }

    render() {

        let compay_list = this.props.company_data.map( ( item, i ) => <Option key={ item.company_id }>{ item.company_name }</Option> )
        let users_list_option = this.state.user_list.map( ( item, i ) => <Option key={ item.user_id }>{ item.full_name }</Option> )

        return (
            <Modal
                title="New Holiday"
                maskClosable={false}
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                >
                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label  className={ ( this.state.company_id === '') ? 'error': '' }>Select Company</label>
                        
                        <Select 
                            className={ ( this.state.company_id === '') ? 'br_error': '' }
                            onChange={ ( value )=> this.setState({ company_id: value }) }
                            style={{ width: '100%' }} >
                            { compay_list }
                        </Select>

                    </Col>
                </Row>
                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label  className={ ( this.state.holiday_name === '') ? 'error': '' }>Holiday Name</label>
                        <Input 
                            className={ ( this.state.holiday_name === '') ? 'br_error': '' } 
                            onChange={ (e)=> this.setState({ holiday_name: e.target.value }) } size="default"  />
                    </Col>
                </Row>
                <Row className="mrg_b_10">
                    <Col span={24}>
                        <label>Select Employees</label>
                        <br />
                        <Select 
                            showSearch
                            mode="multiple"
                            className={ ( this.state.users === '') ? 'br_error': '' }
                            onChange={ this.handleUsers }
                            style={{ width: '100%' }} >
                            <Option key="all">All</Option>
                            { users_list_option }
                        </Select>
                    </Col>
                </Row>
                <Row className="mrg_b_10">
                    <Col span={24}>
                        <label>Select Holidays</label>
                        <br />
                        <RangePicker
                            style={{ width: '100%' }}
                            onChange={ ( Date, dateString ) => this.setState({ holiday_dates: dateString }) } />
                    </Col>
                </Row>
            </Modal>
        )
    }
}

export default NewHoliday


// WEBPACK FOOTER //
// ./src/pages/holidays/childs/new.holiday.js